import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { GanttWidget as mainModule } from './main';
import * as $ from 'jquery';
//import mainTheme = require('./themes/main'); //LL: 05.11.24 was by LL
//import { ganttTheme as mainTheme } from './themes/main'; //LL: 05.11.24 was by OE
//import { init as mainTheme } from '../../../_common/application/tsx/gantt/theme/main'; //LL: 05.11.24 try, ok with OE err, direct link
import { init as mainTheme } from './themes/main'; //LL: 05.11.24
import * as Config from './config';

declare var require: any;
require('../sass/pdc-widget-gantt.sass');

export class GanttWidget extends WidgetBase {
    public static _name: string = Config.name;
    public static group = Config.group;
    public static moduleName: string = Config.moduleName;
    public static icon: string = Config.icon;
    public static namespace: string = Config.namespace;

    public static themeModule = mainTheme;

    public static load() {
        let def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                let module: typeof mainModule = require('./main');
                def.resolve(module);
            },
            'pdc-widget-gantt'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        values['themeNodeIdToExpand'] = Config.themeId;
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(GanttWidget);
